import { ROLES } from "./roles";

export enum PERMISSIONS {
  CanViewSchoolArea,
  CanViewTeacherArea,
  CanUpdateNotOwnedVacancy,
  CanSelectAbsentTeacherOnCreateVacancy,
  CanAcceptTeacherOnVacancy,
  CanDeleteVacancy,
  CanUpdateVacancy,
}

export const PERMISSIONS_MAP: {
  [K in ROLES]: PERMISSIONS[];
} = {
  TEACHER: [PERMISSIONS.CanViewTeacherArea, PERMISSIONS.CanUpdateVacancy],
  SECRETARY: [
    PERMISSIONS.CanViewSchoolArea,
    PERMISSIONS.CanUpdateNotOwnedVacancy,
    PERMISSIONS.CanSelectAbsentTeacherOnCreateVacancy,
    PERMISSIONS.CanAcceptTeacherOnVacancy,
    PERMISSIONS.CanDeleteVacancy,
    PERMISSIONS.CanUpdateVacancy
  ],
  ADMIN: Object.values(PERMISSIONS).map(
    (value) => PERMISSIONS[value as keyof typeof PERMISSIONS],
  ),
};
